/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, lockedBy: NonNullable<unknown> }} Explorer_Kanban_Move_Locked_ToastInputs */

const en_explorer_kanban_move_locked_toast = /** @type {(inputs: Explorer_Kanban_Move_Locked_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cannot move "${i?.name}" as it is locked by ${i?.lockedBy}`)
};

const fr_explorer_kanban_move_locked_toast = /** @type {(inputs: Explorer_Kanban_Move_Locked_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossible de deplacer "${i?.name}" car il est verrouille par ${i?.lockedBy}`)
};

const de_explorer_kanban_move_locked_toast = /** @type {(inputs: Explorer_Kanban_Move_Locked_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`"${i?.name}" kann nicht verschoben werden, da es von ${i?.lockedBy} gesperrt ist.`)
};

const it_explorer_kanban_move_locked_toast = /** @type {(inputs: Explorer_Kanban_Move_Locked_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile spostare "${i?.name}" perché è bloccato da ${i?.lockedBy}`)
};

const ru_explorer_kanban_move_locked_toast = /** @type {(inputs: Explorer_Kanban_Move_Locked_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Невозможно переместить "${i?.name}", так как он заблокирован ${i?.lockedBy}.`)
};

const es_explorer_kanban_move_locked_toast = /** @type {(inputs: Explorer_Kanban_Move_Locked_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se puede mover "${i?.name}" ya que está bloqueado por ${i?.lockedBy}`)
};

const zh_cn2_explorer_kanban_move_locked_toast = /** @type {(inputs: Explorer_Kanban_Move_Locked_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`无法移动“${i?.name}”，因为它被“${i?.lockedBy}”锁定。`)
};

const ja_explorer_kanban_move_locked_toast = /** @type {(inputs: Explorer_Kanban_Move_Locked_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.name}」は${i?.lockedBy}によってロックされているため移動できません`)
};

const hi_explorer_kanban_move_locked_toast = /** @type {(inputs: Explorer_Kanban_Move_Locked_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`"${i?.name}" को स्थानांतरित नहीं किया जा सकता क्योंकि यह ${i?.lockedBy} द्वारा लॉक किया गया है।`)
};

const pt_pt2_explorer_kanban_move_locked_toast = /** @type {(inputs: Explorer_Kanban_Move_Locked_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Não é possível mover "${i?.name}" porque está bloqueado por ${i?.lockedBy}`)
};

/**
* | output |
* | --- |
* | "Cannot move \"{name}\" as it is locked by {lockedBy}" |
*
* @param {Explorer_Kanban_Move_Locked_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_kanban_move_locked_toast = /** @type {((inputs: Explorer_Kanban_Move_Locked_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Kanban_Move_Locked_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_kanban_move_locked_toast(inputs)
	if (locale === "de") return de_explorer_kanban_move_locked_toast(inputs)
	if (locale === "it") return it_explorer_kanban_move_locked_toast(inputs)
	if (locale === "ru") return ru_explorer_kanban_move_locked_toast(inputs)
	if (locale === "es") return es_explorer_kanban_move_locked_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_kanban_move_locked_toast(inputs)
	if (locale === "ja") return ja_explorer_kanban_move_locked_toast(inputs)
	if (locale === "hi") return hi_explorer_kanban_move_locked_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_kanban_move_locked_toast(inputs)
	return en_explorer_kanban_move_locked_toast(inputs)
});